import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';

const buyItNowCookieKey = '_app_biy';

// This doesn't have to be observable but, since it's use is going to be replaced by an SSO call, it's easier to just
// make it an observable now.
export const fakeHasCustomIDPForVBC = (partnerId: string) => {
  return of(partnerId == 'X9DY' || partnerId == 'FREN');
};

@Injectable({ providedIn: 'root' })
export class AuthWallService {
  private inBuyItNowWorkflow = false;

  constructor(private cookieService: CookieService) {
    const biyCookie = this.cookieService.get(buyItNowCookieKey);
    if (biyCookie) {
      this.inBuyItNowWorkflow = true;
      this.cookieService.delete(buyItNowCookieKey, '/');
    }
  }

  isInBuyItNowWorkflow(): boolean {
    return this.inBuyItNowWorkflow;
  }
}
